import Vue from 'vue'
import Router from 'vue-router'
import { clearLoginInfo } from '@/utils'
import login from '@/views/login'
import home from '@/views/index'
import bicycleSystem from '@/views/bicycle-system/index'
import carSystem from '@/views/car-system/index'

Vue.use(Router)

const globalRoutes = [
  {
    path:'/',
    redirect:'/login'
  },
  { path: '/login', component: login, name: 'login', meta: { title: '登录' } },
  { path: '/home', component: home, name: 'home', meta: { title: '首页' } },
  { path: '/bicycleSystem', component: bicycleSystem, name: 'bicycleSystem', meta: { title: '自行车管理系统' } },
  { path: '/carSystem', component: carSystem, name: 'carSystem', meta: { title: '电动汽车管理系统' } },
]
// const mainRoutes = {
//   path: '/',
//   component: home,
//   redirect: { name: 'home' },
//   meta: { title: '首页' },
//   children:[],
//   beforeEnter (to, from, next) {
//     let authorization = Vue.cookie.get('Authorization')
//     if (!authorization || !/\S/.test(authorization)) {
//       clearLoginInfo()
//       next({ name: 'login' })
//     }
//     next()
//   }
// }
// export default new Router({
//   routes: globalRoutes
// })

// 定义一个路由对象 router
const router = new Router({
  routes: globalRoutes
})

// 路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()
  const tokenStr = Vue.cookie.get('Authorization')
  if (!tokenStr) return next('/login')
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js